import hljs from 'highlight.js/lib/highlight'
import 'highlight.js/styles/vs2015.css'
import scss from 'highlight.js/lib/languages/scss'
import javascript from 'highlight.js/lib/languages/javascript'
import xml from 'highlight.js/lib/languages/xml'
import apache from 'highlight.js/lib/languages/apache'
import php from 'highlight.js/lib/languages/php'
import json from 'highlight.js/lib/languages/json'
import sql from 'highlight.js/lib/languages/sql'
import less from 'highlight.js/lib/languages/less'

hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('xml', xml)
hljs.registerLanguage('scss', scss)
hljs.registerLanguage('apache', apache)
hljs.registerLanguage('php', php)
hljs.registerLanguage('json', json)
hljs.registerLanguage('sql', sql)
hljs.registerLanguage('less', less)

hljs.initHighlightingOnLoad()



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/highlight/script.js